import { render, staticRenderFns } from "./TextBoxImgRight.vue?vue&type=template&id=0047c84c&scoped=true&"
var script = {}
import style0 from "./TextBoxImgRight.vue?vue&type=style&index=0&id=0047c84c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047c84c",
  null
  
)

export default component.exports